module.exports = __webpack_public_path__ + "static/media/ICON_ADVISOR.8e90614d.svg";